import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VRow,
    [
      _c(
        VCol,
        { attrs: { cols: "9" } },
        [
          _c(
            "AtTextField",
            _vm._b(
              {
                model: {
                  value: _vm.amount,
                  callback: function ($$v) {
                    _vm.amount = $$v
                  },
                  expression: "amount",
                },
              },
              "AtTextField",
              _vm.$attrs,
              false
            )
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        VCol,
        { attrs: { cols: "3" } },
        [
          _c(VSelect, {
            attrs: { outlined: "", items: _vm.items },
            model: {
              value: _vm.time,
              callback: function ($$v) {
                _vm.time = $$v
              },
              expression: "time",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }